export enum RoleType {
  ADMIN = "ADMIN",
  PROVIDER = "PROVIDER",
  USER = "USER",
}
